var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{ref:"btn",staticClass:"uploader-btn",class:_vm.options.disabled ? 'uploader-btn-disabled' : '',on:{"click":_vm.handleClick}},[_c('i',{staticClass:"el-icon-upload mr-5"}),_vm._v(" "+_vm._s(_vm.uploadBtnText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }